import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export default function transformer(serverTableData) {
  if (serverTableData.query.affectation) {
    serverTableData.query.reseau = serverTableData.query.affectation;
    delete serverTableData.query.affectation;
  }
  if (serverTableData.query.nomAfficheur) {
    serverTableData.query.afficheurs = serverTableData.query.nomAfficheur;
    delete serverTableData.query.nomAfficheur;
  }
  if (serverTableData.query.actionLogistique && !serverTableData.query.actionLogistique.startsWith('[')) {
    serverTableData.query.actionLogistique = serverTableData.query.actionLogistique.split(',');
  }
  if (serverTableData.query.affecter !== undefined) {
    serverTableData.query.estAffectee = serverTableData.query.affecter;
    delete serverTableData.query.affecter;
  }
  if (serverTableData.orderBy === 'affectationLogistiqueLibelle') {
    serverTableData.orderBy = 'AffectationLogistiqueLigneCommandeLibelle';
  }
  if (serverTableData.orderBy === 'affectation') {
    serverTableData.orderBy = 'produitsRegroupementsReferences';
  }
  if (serverTableData.orderBy === 'adresse') {
    serverTableData.orderBy = 'adresse.adresse1';
  }
  if (serverTableData.orderBy === 'ville') {
    serverTableData.orderBy = 'adresse.ville';
  }
  if (serverTableData.orderBy === 'codePostal') {
    serverTableData.orderBy = 'adresse.codePostal';
  }
  return generalTransformer(serverTableData);
}
